import { CollectingCompanyTableItem } from 'components/waste-management/interfaces'
import * as Yup from 'yup'

export const getInitialValues = (editItem: CollectingCompanyTableItem) => ({
  name: editItem?.name ?? '',
  email: editItem?.email ?? '',
  contactNumber: editItem?.contactNumber ?? '',
  contractNumber: editItem?.contractNumber ?? '',
  tradeRegisterNumber: editItem?.tradeRegisterNumber ?? '',
  cif: editItem?.cif ?? '',
  headquarter: editItem?.headquarter ?? '',
  county: editItem?.county ?? '',
  iban: editItem?.iban ?? '',
  bank: editItem?.bank ?? '',
  environmentalPermitNumber: editItem?.environmentalPermitNumber ?? '',
  environmentalPermitExpirationDate: editItem?.environmentalPermitExpirationDate ?? '',
  metiCodes: [],
  metiCodesCsv: null
})

export const getValidationSchema = () =>
  Yup.object({
    name: Yup.string().nonNullable().required('Acest camp este obligatoriu.'),
    email: Yup.string().nonNullable().email('Adresa de email invalida.'),
    contactNumber: Yup.string().nullable(),
    contractNumber: Yup.string().nullable(),
    tradeRegisterNumber: Yup.string().nullable(),
    cif: Yup.string().nonNullable().required('Acest camp este obligatoriu.'),
    headquarter: Yup.string().nullable(),
    county: Yup.string().nullable(),
    iban: Yup.string().nullable(),
    bank: Yup.string().nullable(),
    environmentalPermitNumber: Yup.string().nullable(),
    environmentalPermitExpirationDate: Yup.string().nullable(),
    metiCodes: Yup.array(),
    metiCodesCsv: Yup.mixed().nullable()
  })
